//--
import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';

import { RequestType } from '../../../types/enums/request-enums';
//#region comment metod
const GetShippingCompanyRedirectManagement = () =>
    request({
        url: ApiURL.Query.GetShippingCompanyRedirectManagement,
        method: RequestType.GET,
    });

const CargoPrioritizationQuery = {
    GetShippingCompanyRedirectManagement,
};

export default CargoPrioritizationQuery;
